import variables from '../variables';

const shape = {
  borderRadius: variables.border.borderRadius,
};

export default shape;
